import React from "react"
import SanityContentWrapper from "@/components/SanityContentWrapper"
import TypeformQuiz from "@/components/TypeformQuiz"

const TypeformQuizContainer = ({ title, description, selectedQuizId }) => {
  return (
    <section className="mt-20">
      <div className="container-fluid">
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-8 col-md-7 mt-10 mb-5">
            {title && <h1>{title}</h1>}
            {description && (
              <div className="p--lg mt-6">
                <SanityContentWrapper>{description}</SanityContentWrapper>
              </div>
            )}
          </div>
        </div>
        <div className="col-xs-12 typeform-quiz__container">
          <TypeformQuiz selectedQuizId={selectedQuizId} title={title} />
        </div>
      </div>
    </section>
  )
}

export default TypeformQuizContainer
